import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-align-items-center ns-clickable ns-p-0`}
            onClick={() => filter.remove()}
        >
            <svg xmlns='http://www.w3.org/2000/svg' width="10" height="10" aria-hidden='true' focusable='false' role='presentation' class='icon icon-close' fill='none' viewBox='0 0 18 18'>
                <path d="M17 1L1.22665 16.7733L17 1Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M16.7733 16.7733L1 1L16.7733 16.7733Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
            </svg>
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-flex-column ns-flex-l-row ns-align-items-l-center ns-gap-l-x-6">
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-gap-xs">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            class="ns-selected-filter inline-flex items-center gap-x-xs py-xs px-sm border border-t-brand-accent-01 text-t-brand-foreground-secondary transition-[color,border-color] duration-300 ease-out hover:no-underline hover:text-t-brand-foreground hover:border-t-brand-foreground"
                        >
                            <span class="utility font-normal tracking-normal ns-normal-case">
                                {filter.name}: {filter.value}
                            </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                <div class="mt-3 ns-mt-l-0">
                    <span
                        class="ns-anchor utility pb-0.5 text-t-brand-foreground border-b border-t-brand-accent-02 transition-[color, border-color] hover:no-underline hover:text-t-brand-foreground-secondary hover:border-t-brand-foreground-secondary focus:text-t-brand-foreground-secondary focus:border-u-focus"
                        onClick={() => {
                            removeAll()
                        }}
                    >
                        Clear All
                    </span>
                </div>
            </div>
        )
    )
}
